<template>
  <NotificationCondensed :show="!!props.update" @close="emit('dismiss')">
    <span class="flex items-start gap-2" data-testid="agent-page-updated-toast">
      <HeroiconContainer
        :icon="SparklesIcon"
        class="mt-0.5 shrink-0"
        color="text-amber-700"
      />
      <span>
        <SpanText font="font-medium" color="text-gray-900">
          Lottie updated this page
        </SpanText>
        <ParagraphText size="text-sm" color="text-gray-500">
          {{ props.update?.summary }}
        </ParagraphText>
      </span>
    </span>

    <template #after>
      <ButtonBase
        size="xs"
        color="white"
        class="ml-3 self-center"
        @click="reload"
      >
        Reload
      </ButtonBase>
    </template>
  </NotificationCondensed>
</template>

<script setup>
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import HeroiconContainer from '@/Common/Elements/HeroiconContainer.vue'
import NotificationCondensed from '@/Common/Overlays/Notifications/NotificationCondensed.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import SpanText from '@/Common/Text/SpanText.vue'
import { SparklesIcon } from '@heroicons/vue/20/solid'
import { router } from '@inertiajs/vue3'
import { onUnmounted } from 'vue'

const props = defineProps({
  // { summary } while a notice is pending, null otherwise.
  update: Object,
})

const emit = defineEmits(['dismiss'])

// The notice is about the page it was raised on; navigating away retires it.
const stopListening = router.on('navigate', () => emit('dismiss'))
onUnmounted(() => stopListening())

function reload() {
  emit('dismiss')
  // A full rebuild of the page component (not a partial prop reload): the
  // component remounts, so pages that copy props into local state on mount
  // pick up the agent's changes too.
  router.visit(window.location.href, {
    preserveState: false,
    preserveScroll: true,
    replace: true,
  })
}
</script>
